import { Component, OnInit, Inject } from '@angular/core';
import {
  MatExpansionPanel,
  MatDialogRef,
  MatCheckboxChange,
  MAT_DIALOG_DATA,
} from "@angular/material";

@Component({
  selector: 'app-common-gridcolumn-showhide-modal',
  templateUrl: './common-gridcolumn-showhide-modal.component.html',
  styleUrls: ['./common-gridcolumn-showhide-modal.component.css']
})
export class CommonGridcolumnShowhideModalComponent implements OnInit {

  columns: any[];

  constructor(
    public dialogRef: MatDialogRef<CommonGridcolumnShowhideModalComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    const { pages, screenName, tableName, columnApi } = this.data;

    const pageData = pages?.find(
      (page: any) => page.screenName === screenName && page.tableName === tableName
    );

    if (pageData) {
      this.columns = (pageData.columns ?? []).flat().map((col: any) => {
        const isMandatory = col.field === 'FirstName' || col.field === 'LastName';
        return {
          ...col,
          isChecked: columnApi?.getColumn(col.field)?.isVisible() ?? !col.hide,
          isDisabled: isMandatory // add flag to disable checkbox
        };
      }).sort((a: any, b: any) => a.headerName?.localeCompare(b.headerName));
      
    //   this.columns = (pageData.columns ?? []).flat().map((col: any) => ({
    //     ...col,
    //     isChecked: columnApi?.getColumn(col.field)?.isVisible() ?? !col.hide
    //   }));
    //   console.log("this.columns", this.columns)
    // } else {
    //   console.warn("No header data found for", screenName, tableName);
    // }
  }
}

  ngOnInit(): void {
  }

  toggleColumn(col: any) {
    if (col.isDisabled) return;
    this.data?.columnApi?.setColumnVisible(col.field, col.isChecked);
  }

  onSaveClick(): void {
    const updatedColumns = this.columns?.map(col => ({
      field: col.field,
      isChecked: col.isDisabled ? true : col.isChecked
    }));
    this.dialogRef.close(updatedColumns);
  }

  onNoClick(): void {
    this.dialogRef.close(false);
  }

}

